import store from "@/store/store";
import tools from "@/class/tools";

export class Media {
    
    id = ""
    media = ""
    size = 0
    type = "picture"
    delete = true
    
    constructor (data) {
        // console.log(data)
        this.setMedia(data);
        return this;
    }
    setMedia(data){
        if(data == null) return this;
        
        if (typeof data === "string"){
            this.media = data;
            this.delete = false
            return this;
        }
        this.id = data.id || "";
        this.media = data.url || "";
        this.size = data.size || 0;
        this.type = data.type || "picture";
        this.delete = data.delete || this.delete;
        
        if(this.id !== "" || this.media !== ""){
            this.delete = false;
        }
        
        if(this.type === "picture"){
            if(this.media !== "" && !this.media.match(/https?/)){
                this.media = "http://localhost:8000"+this.media
            }
        }
        
        return this;
    }
    hasMedia() {
        return this.media !== "";
    }
    getMediaId() {
        if(this.id === "") return null;
        return this.id;
    }
    getMediaUrl() {
        if(this.media === "") return store.getters.getDefaultMedia(this.type)
        return this.media;
    }
    sizeToString(){
        return tools.sizeToString(this.size)
    }
    valueOf(){
        return this
    }
    getReq(){
        if(this.id !== ""){
            return this.id;
        }
        if(this.delete){
            return null;
        }
        return "__delete__";
    }
    toReq(){
        return {
            url:this.media,
            size:this.size
        }
    }
}

export class PK{
    name = "pk";
    
    constructor(name) {
        this.name = name
        return this;
    }
    set(value){
        this[this.name] = value;
    }
    get(){
        if(typeof this[this.name] === "string" && this.name.length <= 0) return "";
        if(!this[this.name]) return 0;
        return this[this.name];
    }
}

export class DateTime{
    
    value = new Date();
    
    constructor(date) {
        this.value = new Date(date)
        return this;
    }
    
    valueOf(){
        return this.value;
    }
    
    toReq(){
        return this.value.toISOString()
    }
}